import React from "react";
import { MessageSquarePlus } from "lucide-react";

export default function RichTextToolbar({
  editor,
  IconBtn,
  icons,
  oncomment,
}) {
  if (!editor) return null;

  const groupClass =
    "flex items-center gap-1 px-1 sm:px-2 border-r last:border-none border-slate-200";

  return (
    <div
      className="
        w-full
        overflow-x-auto
        scrollbar-hide
      "
    >
      <div
        className="
          flex flex-nowrap sm:flex-wrap items-center
          gap-1 sm:gap-2
          min-w-max sm:min-w-0

          bg-white/70 backdrop-blur-xl
          px-2 sm:px-3 py-1.5
          rounded-xl border border-slate-200/70
          shadow-[0_4px_20px_rgba(0,0,0,0.05)]
        "
      >
        {/* TEXT STYLE */}
        <div className={groupClass}>
          <IconBtn
            icon={icons.Bold}
            label="Bold"
            active={editor.isActive("bold")}
            onClick={() => editor.chain().focus().toggleBold().run()}
          />
          <IconBtn
            icon={icons.Italic}
            label="Italic"
            active={editor.isActive("italic")}
            onClick={() => editor.chain().focus().toggleItalic().run()}
          />
          <IconBtn
            icon={icons.Underline}
            label="Underline"
            active={editor.isActive("underline")}
            onClick={() => editor.chain().focus().toggleUnderline().run()}
          />
        </div>

        {/* HIGHLIGHT */}
        <div className={groupClass}>
          <IconBtn
            icon={icons.Highlighter}
            label="Highlight"
            active={editor.isActive("highlight")}
            onClick={() => editor.chain().focus().toggleHighlight().run()}
          />
        </div>

        {/* HEADINGS */}
        <div className={groupClass}>
          <IconBtn
            icon={icons.Heading1}
            label="H1"
            active={editor.isActive("heading", { level: 1 })}
            onClick={() =>
              editor.chain().focus().setNode("heading", { level: 1 }).run()
            }
          />
          <IconBtn
            icon={icons.Heading2}
            label="H2"
            active={editor.isActive("heading", { level: 2 })}
            onClick={() =>
              editor.chain().focus().setNode("heading", { level: 2 }).run()
            }
          />
          <IconBtn
            icon={icons.Heading3}
            label="H3"
            active={editor.isActive("heading", { level: 3 })}
            onClick={() =>
              editor.chain().focus().setNode("heading", { level: 3 }).run()
            }
          />
        </div>

        {/* ALIGNMENT */}
        <div className={groupClass}>
          <IconBtn
            icon={icons.AlignLeft}
            label="Left"
            onClick={() =>
              editor.chain().focus().setTextAlign("left").run()
            }
          />
          <IconBtn
            icon={icons.AlignCenter}
            label="Center"
            onClick={() =>
              editor.chain().focus().setTextAlign("center").run()
            }
          />
          <IconBtn
            icon={icons.AlignRight}
            label="Right"
            onClick={() =>
              editor.chain().focus().setTextAlign("right").run()
            }
          />
          <IconBtn
            icon={icons.AlignJustify}
            label="Justify"
            onClick={() =>
              editor.chain().focus().setTextAlign("justify").run()
            }
          />
        </div>

        {/* LIST */}
        <div className={groupClass}>
          <IconBtn
            icon={icons.List}
            label="Bullet List"
            active={editor.isActive("bulletList")}
            onClick={() =>
              editor.chain().focus().toggleBulletList().run()
            }
          />
          <IconBtn
            icon={icons.ListOrdered}
            label="Numbered List"
            active={editor.isActive("orderedList")}
            onClick={() =>
              editor.chain().focus().toggleOrderedList().run()
            }
          />
        </div>

        {/* COMMENT */}
        <div className="flex items-center pl-1 sm:pl-2">
          <IconBtn
            icon={MessageSquarePlus}
            label="Comment"
            onClick={oncomment}
          />
        </div>
      </div>
    </div>
  );
}